var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _path14, _g7, _path15, _g8, _path16, _g9, _path17, _path18, _path19, _g10, _path20, _g11, _path21, _g12, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide6Ill2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 220,
    viewBox: "0 0 359 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.778 128.786L358.928 142.661V69.3604L337.778 79.1582V128.786Z",
    fill: "url(#paint0_linear_7761_85438)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.068 184.953V185.3L317.806 198.987V21.4382L341.068 32.8493C346.442 32.8493 350.772 66.8943 350.772 108.901C350.772 150.908 346.442 184.953 341.068 184.953Z",
    fill: "url(#paint1_linear_7761_85438)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.067 184.95V185.296L317.805 198.984V21.4348L341.067 32.8458C346.441 32.8458 350.771 66.8909 350.771 108.898C350.771 150.905 346.441 184.95 341.067 184.95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.629 41.7601L368.818 52.0973V-9.25806H324.629V41.7601Z",
    fill: "url(#paint2_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.067 184.95V185.296L317.805 198.984V21.4348L341.067 32.8458C346.441 32.8458 350.771 66.8909 350.771 108.898C350.771 150.905 346.441 184.95 341.067 184.95Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.27 143.288L352.287 137.345V69.6063L323.27 64.9004V143.288Z",
    fill: "url(#paint3_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.067 184.95V185.296L317.805 198.984V21.4348L341.067 32.8458C346.441 32.8458 350.771 66.8909 350.771 108.898C350.771 150.905 346.441 184.95 341.067 184.95Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.188 220.735H355.259L352.538 171.142L324.188 178.758V220.735Z",
    fill: "url(#paint4_linear_7761_85438)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 219.914H295.677V0.961426H321.597C328.613 0.961426 334.304 49.9853 334.304 110.425C334.274 170.895 328.613 219.919 321.597 219.919V219.914Z",
    fill: "url(#paint5_linear_7761_85438)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 219.912H295.677V0.959717H321.597C328.613 0.959717 334.304 49.9836 334.304 110.423C334.274 170.893 328.613 219.917 321.597 219.917V219.912Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.267 55.1633H304.307V150.212H350.267V55.1633Z",
    fill: "url(#paint6_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 219.912H295.677V0.959717H321.597C328.613 0.959717 334.304 49.9836 334.304 110.423C334.274 170.893 328.613 219.917 321.597 219.917V219.912Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.688 -84.6418H294.728V10.4072H340.688V-84.6418Z",
    fill: "url(#paint7_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.597 219.912H295.677V0.959717H321.597C328.613 0.959717 334.304 49.9836 334.304 110.423C334.274 170.893 328.613 219.917 321.597 219.917V219.912Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M337.972 187.549H292.011V317.049H337.972V187.549Z",
    fill: "url(#paint8_linear_7761_85438)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.678 219.917C302.696 219.917 308.386 170.908 308.386 110.453C308.386 49.9976 302.696 0.989014 295.678 0.989014C288.66 0.989014 282.971 49.9976 282.971 110.453C282.971 170.908 288.66 219.917 295.678 219.917Z",
    fill: "url(#paint9_linear_7761_85438)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.105 10.1284H59.9062V215.364H292.105C299.122 215.364 304.813 169.403 304.813 112.729C304.813 56.0546 299.122 10.1284 292.105 10.1284Z",
    fill: "url(#paint10_linear_7761_85438)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7442 195.734H299.562C299.562 195.734 296.905 212.36 292.669 215.364H67.7393V195.734H67.7442Z",
    fill: "url(#paint11_linear_7761_85438)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3514 0.957346H48.4316V219.91H74.3514C81.3683 219.91 87.0589 170.886 87.0589 110.446C87.0589 50.006 81.3683 0.952393 74.3514 0.952393V0.957346Z",
    fill: "url(#paint12_linear_7761_85438)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3504 0.956125H48.4307V219.908H74.3504C81.3673 219.908 87.0579 170.885 87.0579 110.445C87.0579 50.0048 81.3673 0.951172 74.3504 0.951172V0.956125Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.6298 58.3594H49.6689V153.408H95.6298V58.3594Z",
    fill: "url(#paint13_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3504 0.956125H48.4307V219.908H74.3504C81.3673 219.908 87.0579 170.885 87.0579 110.445C87.0579 50.0048 81.3673 0.951172 74.3504 0.951172V0.956125Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.0487 -81.4441H40.0879V13.6049H86.0487V-81.4441Z",
    fill: "url(#paint14_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3504 0.956125H48.4307V219.908H74.3504C81.3673 219.908 87.0579 170.885 87.0579 110.445C87.0579 50.0048 81.3673 0.951172 74.3504 0.951172V0.956125Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.1503 190.767H46.1895V320.267H92.1503V190.767Z",
    fill: "url(#paint15_linear_7761_85438)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4302 219.917C55.4484 219.917 61.1377 170.908 61.1377 110.453C61.1377 49.9976 55.4484 0.989014 48.4302 0.989014C41.412 0.989014 35.7227 49.9976 35.7227 110.453C35.7227 170.908 41.412 219.917 48.4302 219.917Z",
    fill: "url(#paint16_linear_7761_85438)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0219 23.1479L26.0547 32.8221V185.273L43.8194 195.734C48.466 195.734 54.1567 151.45 54.1567 109.443C54.1567 67.4362 49.6685 23.1529 45.0219 23.1529V23.1479Z",
    fill: "url(#paint17_linear_7761_85438)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0229 23.147L26.0557 32.8211V185.272L43.8204 195.733C48.467 195.733 54.1576 151.449 54.1576 109.442C54.1576 67.4352 49.6694 23.1519 45.0229 23.1519V23.147Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.3358 36.4589L9.14648 46.7912V-14.5889H53.3358V36.4589Z",
    fill: "url(#paint18_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0229 23.147L26.0557 32.8211V185.272L43.8204 195.733C48.467 195.733 54.1576 151.449 54.1576 109.442C54.1576 67.4352 49.6694 23.1519 45.0229 23.1519V23.147Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.1913 153.411L28.1738 147.468V79.7293L57.1913 74.9888V153.411Z",
    fill: "url(#paint19_linear_7761_85438)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_7761_85438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0229 23.147L26.0557 32.8211V185.272L43.8204 195.733C48.467 195.733 54.1576 151.449 54.1576 109.442C54.1576 67.4352 49.6694 23.1519 45.0229 23.1519V23.147Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_7761_85438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.4314 225.729H17.3604L20.082 176.136L48.4314 183.752V225.729Z",
    fill: "url(#paint20_linear_7761_85438)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.0211 23.1484L33.704 28.9331C34.9362 34.0547 36.6731 39.1417 37.1481 44.2633C40.6269 84.4691 43.784 123.631 38.0982 164.188C36.9601 172.754 33.8327 180.246 31.2051 188.336L43.784 195.734C48.4305 195.734 54.1212 151.451 54.1212 109.444C54.1212 67.4367 49.6627 23.1534 45.0161 23.1534L45.0211 23.1484Z",
    fill: "url(#paint21_linear_7761_85438)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 185.271C29.878 185.271 32.9775 151.15 32.9775 109.061C32.9775 66.9707 29.878 32.8501 26.0547 32.8501C22.2313 32.8501 19.1318 66.9707 19.1318 109.061C19.1318 151.15 22.2313 185.271 26.0547 185.271Z",
    fill: "url(#paint22_linear_7761_85438)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4407 108.27C24.4407 120.25 25.9252 130.681 24.693 132.987C24.505 133.304 21.912 133.081 21.724 133.081C20.2048 133.081 18.9727 121.987 18.9727 108.27C18.9727 94.5527 20.2048 83.4584 21.724 83.4584C21.912 83.4584 24.2823 83.1417 24.4753 83.4584C25.6777 85.799 24.4456 96.2896 24.4456 108.27H24.4407Z",
    fill: "url(#paint23_linear_7761_85438)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4398 133.08C25.9593 133.08 27.1911 121.972 27.1911 108.269C27.1911 94.5659 25.9593 83.4575 24.4398 83.4575C22.9203 83.4575 21.6885 94.5659 21.6885 108.269C21.6885 121.972 22.9203 133.08 24.4398 133.08Z",
    fill: "url(#paint24_linear_7761_85438)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4407 83.4587L0.0400391 59.3748V153.409L24.4407 133.086V83.4587Z",
    fill: "url(#paint25_linear_7761_85438)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.8315 208.188C49.0695 208.188 50.0731 205.824 50.0731 202.908C50.0731 199.992 49.0695 197.628 47.8315 197.628C46.5935 197.628 45.5898 199.992 45.5898 202.908C45.5898 205.824 46.5935 208.188 47.8315 208.188Z",
    fill: "url(#paint26_linear_7761_85438)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.6847 139.915C57.3844 139.915 57.9516 137.551 57.9516 134.635C57.9516 131.719 57.3844 129.355 56.6847 129.355C55.9851 129.355 55.418 131.719 55.418 134.635C55.418 137.551 55.9851 139.915 56.6847 139.915Z",
    fill: "url(#paint27_linear_7761_85438)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.4182 69.929C56.1178 69.929 56.685 67.5651 56.685 64.6491C56.685 61.733 56.1178 59.3691 55.4182 59.3691C54.7186 59.3691 54.1514 61.733 54.1514 64.6491C54.1514 67.5651 54.7186 69.929 55.4182 69.929Z",
    fill: "url(#paint28_linear_7761_85438)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.1594 21.5079C46.859 21.5079 47.4262 19.144 47.4262 16.2279C47.4262 13.3119 46.859 10.948 46.1594 10.948C45.4598 10.948 44.8926 13.3119 44.8926 16.2279C44.8926 19.144 45.4598 21.5079 46.1594 21.5079Z",
    fill: "url(#paint29_linear_7761_85438)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_85438",
    x1: 351.899,
    y1: 101.008,
    x2: 330.69,
    y2: 101.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_85438",
    x1: 337.201,
    y1: -4.98687,
    x2: 335.465,
    y2: 170.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7761_85438",
    x1: 339.677,
    y1: 427.167,
    x2: 339.677,
    y2: 427.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7761_85438",
    x1: 330.716,
    y1: 46.1204,
    x2: 330.716,
    y2: 144.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7761_85438",
    x1: 332.662,
    y1: 159.234,
    x2: 332.662,
    y2: 221.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7761_85438",
    x1: 316.253,
    y1: 218.304,
    x2: 316.253,
    y2: -9.62085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7761_85438",
    x1: 329.483,
    y1: 53.0512,
    x2: 329.483,
    y2: 151.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7761_85438",
    x1: 319.888,
    y1: -87.0254,
    x2: 319.888,
    y2: 11.9111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7761_85438",
    x1: 317.164,
    y1: 185.212,
    x2: 317.164,
    y2: 320.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7761_85438",
    x1: 270.446,
    y1: 427.176,
    x2: 309.409,
    y2: 427.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303256",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2A3861",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#224272",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1D487C",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7761_85438",
    x1: 184.278,
    y1: 9.61834,
    x2: 184.278,
    y2: 213.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7761_85438",
    x1: 185.577,
    y1: 215.789,
    x2: 185.577,
    y2: 195.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7761_85438",
    x1: 69.4443,
    y1: -3.0481,
    x2: 69.4443,
    y2: 224.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7761_85438",
    x1: 74.3534,
    y1: 56.2763,
    x2: 74.3534,
    y2: 155.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7761_85438",
    x1: 64.7565,
    y1: -83.8067,
    x2: 64.7565,
    y2: 15.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7761_85438",
    x1: 70.869,
    y1: 188.426,
    x2: 70.869,
    y2: 323.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7761_85438",
    x1: 36.0946,
    y1: 207.045,
    x2: 61.9688,
    y2: 27.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95AAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BBC8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C2CEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7761_85438",
    x1: 41.7488,
    y1: -17.3863,
    x2: 41.7488,
    y2: 199.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7761_85438",
    x1: 32.866,
    y1: -29.5825,
    x2: 32.866,
    y2: 47.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7761_85438",
    x1: 44.3312,
    y1: 56.2537,
    x2: 44.3312,
    y2: 154.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7761_85438",
    x1: 34.5282,
    y1: 164.242,
    x2: 34.5282,
    y2: 226.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7761_85438",
    x1: 32.8582,
    y1: 427.176,
    x2: 55.8189,
    y2: 427.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#678ADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00112C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7761_85438",
    x1: 15.7574,
    y1: 196.548,
    x2: 39.5161,
    y2: 20.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7761_85438",
    x1: 20.5039,
    y1: 136.544,
    x2: 28.3105,
    y2: 78.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7761_85438",
    x1: 22.172,
    y1: 136.356,
    x2: 29.9121,
    y2: 79.1449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEBD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F4B840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F45C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7761_85438",
    x1: 1.60651,
    y1: 105.774,
    x2: 28.3422,
    y2: 105.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7761_85438",
    x1: 47.2424,
    y1: 202.494,
    x2: 51.7141,
    y2: 202.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7761_85438",
    x1: 57.0955,
    y1: 134.078,
    x2: 59.6417,
    y2: 134.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7761_85438",
    x1: 55.8194,
    y1: 63.9597,
    x2: 58.3625,
    y2: 63.9438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7761_85438",
    x1: 46.524,
    y1: 15.4437,
    x2: 49.0702,
    y2: 15.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide6Ill2);
export default __webpack_public_path__ + "static/media/slide_6_ill_2.2c0244fd16503c172c3b582955738875.svg";
export { ForwardRef as ReactComponent };